import React from "react";
import { Home, Settings } from "lucide-react";
import { useApp } from "@/context/AppContext";

export function BottomNav({ view, setView }) {
  const { t } = useApp();
  const items = [
    { key: "library", label: t("home"), icon: Home, testid: "nav-library" },
    { key: "settings", label: t("settings"), icon: Settings, testid: "nav-settings" },
  ];
  return (
    <nav
      data-testid="bottom-nav"
      className="backdrop-blur-2xl bg-black/50 border-t border-white/10 px-6 pt-2 pb-[max(env(safe-area-inset-bottom),10px)] flex items-center justify-around"
    >
      {items.map((it) => {
        const Icon = it.icon;
        const active = view === it.key;
        return (
          <button
            key={it.key}
            data-testid={it.testid}
            onClick={() => setView(it.key)}
            className="flex flex-col items-center gap-1 px-6 py-1 transition-colors"
          >
            <Icon className={`h-6 w-6 ${active ? "text-[#ff3366]" : "text-white/55"}`} strokeWidth={active ? 2.5 : 2} />
            <span className={`text-[11px] font-medium ${active ? "text-white" : "text-white/55"}`}>{it.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
